export const locale = {
    lang: 'en',
    data: {
        MAIL: {
            COMPOSE                 : 'COMPOSE',
            FOLDERS                 : 'FOLDERS',
            FILTERS                 : 'FILTERS',
            LABELS                  : 'LABELS',
            NO_MESSAGES             : 'There are no messages!',
            SELECT_A_MESSAGE_TO_READ: 'Select a message to read',
            SEARCH_PLACEHOLDER      : 'Search for an e-mail or contact'
        }
    }
};
